module.exports = __webpack_public_path__ + "img/01.ad330e75.png";